export default __webpack_public_path__ + "static/skeletonmage_scaled-8303659fecedab6c2cf497b9092c696a.gif";